import React from "react";
import './toggleButton.scss'

// gridView -  based on true and false it will show grid view if gridview = true it will show gridview
// setGridViewfun - we are just toggeling true false value if it is true we r setting that as false or vise versa

const ToggleButton = (props) => {
    const {value,onClick} = props

  return (
    <>
    <span className="common_toggle">
      <label class="switch_toggle">
        <input
          type="checkbox"
          value={value}
          autoComplete={false}
          onClick={onClick}
        />
        <span class="slider_toggle"></span>
      </label>
      </span>
    </>
  );
};

export default ToggleButton;
